import { __assign, __awaiter, __generator } from "tslib";
export var middlewareServerExecutor = function (middlewares, ctx, data, middlewaresArgs) {
    if (data === void 0) { data = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _loop_1, _i, middlewares_1, middleware, state_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _loop_1 = function (middleware) {
                        var finish, done;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    finish = false;
                                    done = function () {
                                        finish = true;
                                    };
                                    return [4 /*yield*/, middleware.functionMiddleware(ctx, data, middlewaresArgs[middleware.id]
                                            ? middlewaresArgs[middleware.id](__assign({ ctx: ctx }, data))
                                            : {}, done)];
                                case 1:
                                    _b.sent();
                                    if (finish) {
                                        return [2 /*return*/, "break"];
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, middlewares_1 = middlewares;
                    _a.label = 1;
                case 1:
                    if (!(_i < middlewares_1.length)) return [3 /*break*/, 4];
                    middleware = middlewares_1[_i];
                    return [5 /*yield**/, _loop_1(middleware)];
                case 2:
                    state_1 = _a.sent();
                    if (state_1 === "break")
                        return [3 /*break*/, 4];
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var middlewareClientExecutor = function (middlewares, data, middlewaresArgs) {
    if (data === void 0) { data = {}; }
    var _loop_2 = function (middleware) {
        var finish = false;
        var done = function () {
            finish = true;
        };
        middleware.functionMiddleware({}, data, middlewaresArgs[middleware.id]
            ? middlewaresArgs[middleware.id](__assign({ ctx: {} }, data))
            : {}, done);
        if (finish) {
            return "break";
        }
    };
    for (var _i = 0, middlewares_2 = middlewares; _i < middlewares_2.length; _i++) {
        var middleware = middlewares_2[_i];
        var state_2 = _loop_2(middleware);
        if (state_2 === "break")
            break;
    }
};
//# sourceMappingURL=middleware-executor.js.map